<template>
  <div
    class="ts-bg-gray-200 ts-border-blue-500 ts-rounded-md ts-p-3 ts-space-y-3"
  >
    <div>
      <label class="required">{{ $t('quotation.date') }}</label>
      <a-date-picker
        v-model="model.contract_date"
        format="DD-MM-YYYY"
        valueFormat="DD-MM-YYYY"
        class="ts-w-full"
      ></a-date-picker>
      <div class="validate" v-if="errors.has('contract_date')">
        {{ errors.first('contract_date') }}
      </div>
    </div>
    <div class="ts-w-full">
      <div>
        <label>{{ $t('saleContract.referenceNo') }}</label>
        <ReferenceNumber v-model="model" />
        <div class="validate" v-if="errors.has('reference_no')">
          {{ errors.first('reference_no') }}
        </div>
      </div>
      <!-- <div>
        <label>{{ $t('saleContract.projectName') }}</label>
        <input
          v-model.trim="model.project_name"
          type="text"
          class="form-control"
        />
        <div class="validate" v-if="errors.has('project_name')">
          {{ errors.first('project_name') }}
        </div>
      </div> -->
    </div>
    <div>
      <label>{{ $t('wholesale.employee') }}</label>
      <a-select
        show-search
        style="width: 100%"
        :default-active-first-option="false"
        :show-arrow="false"
        :filter-option="false"
        :not-found-content="null"
        :loading="fetch_sale"
        @search="handleSaleSearch"
        v-model="model.seller_id"
        :options="employeeList"
        class="ts-w-full"
      ></a-select>
      <div class="validate" v-if="errors.has('seller_id')">
        {{ errors.first('seller_id') }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ReferenceNumber from './reference-number.vue'
import { Errors } from 'form-backend-validation'
import { debounce } from 'lodash'

export default {
  name: 'refDate',
  props: ['value', 'validate'],
  components: {
    ReferenceNumber
  },
  data() {
    return {
      errors: new Errors(),
      fetch_sale: false,
      model: {}
    }
  },
  created() {
    this.model = this.value
    this.handleSaleSearch(null)
  },
  computed: {
    ...mapState('wholesale/saleContract', ['employees']),
    employeeList () {
      return this.employees.map(el => ({
        value: el.employee_id,
        label: el.employee_name_en
      }))
    }
  },
  methods: {
    ...mapActions('wholesale/saleContract', ['getSale']),
    handleSaleSearch: debounce(function (value) {
      this.fetch_sale = true
      this.getSale(value).finally(() => (this.fetch_sale = false))
    }, 500)
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
